export type ImageDetails = {
   preview: string;
   fullLink: string;
   caption: string;
   altText: string;
}

const imageData: Array<ImageDetails> = [
   {
      preview: "BBC3_YM2022_final_group_preview-min.jpg",
      fullLink: "BBC3_YM2022_final_group.jpg",
      caption: "Ethan, BBC Young Musician 2022 - Final",
      altText: "Ethan, BBC Young Musician 2022 - Final, standing with all the competitors smiling"
   },
   {
      preview: "BBC3_YM2022_final_orchestra1_preview-min.jpg",
      fullLink: "BBC3_YM2022_final_orchestra1.jpg",
      caption: "Ethan, BBC Young Musician 2022 - Final",
      altText: "Ethan, BBC Young Musician 2022 - Final, playing piano, in front of orchestra"
   },
   {
      preview: "BBC3_YM2022_final_orchestra2_preview-min.jpg",
      fullLink: "BBC3_YM2022_final_orchestra2.jpg",
      caption: "Ethan, BBC Young Musician 2022 - Final",
      altText: "Ethan, BBC Young Musician 2022 - Final, playing piano, in front of orchestra"
   },
   {
      preview: "BBC3_YM2022_final_orchestra3_preview-min.jpg",
      fullLink: "BBC3_YM2022_final_orchestra3.jpg",
      caption: "Ethan, BBC Young Musician 2022 - Final",
      altText: "Ethan, BBC Young Musician 2022 - Final, playing piano, in front of orchestra"
   },
   {
      preview: "BBC3_YM2022_final_orchestra4_preview-min.jpg",
      fullLink: "BBC3_YM2022_final_orchestra4.jpg",
      caption: "Ethan, BBC Young Musician 2022 - Final",
      altText: "Ethan, BBC Young Musician 2022 - Final, standing with all the competitors smiling"
   },
   {
      preview: "2023_Fali_preview-min.jpg",
      fullLink: "2023_Fali.jpg",
      caption: "Ethan, 2023 with teacher Fali Pavri",
      altText: "Ethan, 2023 with teacher Fali Pavri, Ethan plays while Fali stands over him teaching"
   },
   {
      preview: "BBC3_YM202_Keyboard_Before_preview-min.jpg",
      fullLink: "BBC3_YM202_Keyboard_Before.jpg",
      caption: "Ethan, BBC Young Musician 2022 relaxing before the Keyboard final",
      altText: "Ethan, BBC Young Musician 2022 relaxing before the Keyboard final"
   },
   {
      preview: "2022_Rehearsal_preview-min.jpg",
      fullLink: "2022_Rehearsal.jpg",
      caption: "Ethan, BBC Young Musician 2022 practising for Keyboard final",
      altText: "Ethan, BBC Young Musician 2022 practising for Keyboard final"
   },
   {
      preview: "BBC3_YM202_Keyboard_Fali_preview-min.jpg",
      fullLink: "BBC3_YM202_Keyboard_Fali.jpg",
      caption: "Ethan, BBC Young Musician 2022 relaxing with Fali after the Keyboard final",
      altText: "Ethan, BBC Young Musician 2022 relaxing with Fali after the Keyboard final"
   },
   {
      preview: "Ethan_BBC_2022_preview-min.jpg",
      fullLink: "Ethan_BBC_2022.jpg",
      caption: "Ethan, BBC Young Musician 2022 with Keyboard final trophy",
      altText: "Ethan, BBC Young Musician 2022 with Keyboard final trophy"
   },
   {
      preview: "BBC3_YM2022_Category_Final_preview-min.jpg",
      fullLink: "BBC3_YM2022_Category_Final.jpg",
      caption: "Ethan, BBC Young Musician 2022 Keyboard final",
      altText: "Ethan, BBC Young Musician 2022 Keyboard final"
   },
   {
      preview: "2022_Family_preview-min.jpg",
      fullLink: "2022_Family.jpg",
      caption: "Ethan, 2022 with Fali and family",
      altText: "Ethan, 2022 with Fali and family"
   },
   {
      preview: "2022_Fali_preview-min.jpg",
      fullLink: "2022_Fali.jpg",
      caption: "Ethan, 2022 with Fali",
      altText: "Ethan, 2022 with Fali playing on two pianos"
   },
   {
      preview: "2022_Ethan_Luna_preview-min.jpg",
      fullLink: "2022_Ethan_Luna.jpg",
      caption: "Ethan, 2022 with dog Luna",
      altText: "Ethan, 2022 with dog Luna"
   },
   {
      preview: "Ethan_2018_CBC_preview-min.jpg",
      fullLink: "Ethan_2018_CBC.jpg",
      caption: "Ethan 2018, recording audio for CBC documentary",
      altText: "2018, CBC documentary"
   },
   {
      preview: "Ethan_2018_Matzovia_Poland_preview-min.jpg",
      fullLink: "Ethan_2018_Matzovia_Poland.jpg",
      caption: "Ethan 2018, Matzovia Poland",
      altText: "Ethan 2018, Matzovia Poland"
   },
   {
      preview: "Ethan_2018_Little_Big_Shots_UK_preview-min.jpg",
      fullLink: "Ethan_2018_Little_Big_Shots_UK.jpg",
      caption: "Ethan 2018, Little Big Shots UK",
      altText: "Ethan 2018, Little Big Shots UK"
   },
   {
      preview: "Ethan_2018_Mysterious_Pathways_Volume_One_preview-min.jpg",
      fullLink: "Ethan_2018_Mysterious_Pathways_Volume_One.jpg",
      caption: "Ethan 2018, Recording Mysterious Pathways Volume One",
      altText: "Ethan 2018, Recording Mysterious Pathways Volume One"
   },
   {
      preview: "Ethan_2017_Loretto_preview-min.jpg",
      fullLink: "Ethan_2017_Loretto.jpg",
      caption: "Ethan 2017, After Winning the Loretto Piano Competition",
      altText: "Ethan 2017, After Winning the Loretto Piano Competition"
   },
   {
      preview: "2016_Vatican_Award_01_preview-min.jpg",
      fullLink: "2016_Vatican_Award_01.jpg",
      caption: "Ethan 2016, Receiving an award in the Vatican",
      altText: "Ethan 2016, Receiving an award in the Vatican"
   },
   {
      preview: "2016_Vatican_Award_02_preview-min.jpg",
      fullLink: "2016_Vatican_Award_02.jpg",
      caption: "Ethan 2016, Receiving an award in the Vatican",
      altText: "Ethan 2016, Receiving an award in the Vatican"
   },
   {
      preview: "Ethan_and_Daniel_Kish_2014_preview-min.jpg",
      fullLink: "Ethan_and_Daniel_Kish_2014.jpg",
      caption: "Ethan and Daniel Kish, 2014. Learning to navigate in the rain.",
      altText: "Ethan and Daniel Kish, 2014. Learning to navigate in the rain."
   },
   {
      preview: "Ethan_2009_Brailling_preview-min.jpg",
      fullLink: "Ethan_2009_Brailling.jpg",
      caption: "Ethan 2009 Brailling",
      altText: "Ethan 2009 Brailling"
   },
   {
      preview: "Ethan_Age_3_At_the_Piano_preview-min.jpg",
      fullLink: "Ethan_Age_3_At_the_Piano.jpg",
      caption: "Ethan Age 3 At the Piano",
      altText: "Ethan Age 3 At the Piano"
   },
   {
      preview: "Ethan_Age_3_Dollar_Castle_preview-min.jpg",
      fullLink: "Ethan_Age_3_Dollar_Castle.jpg",
      caption: "Ethan Age 3 Standing In Front of Dollar Castle",
      altText: "Ethan Age 3 Standing In Front of Dollar Castle"
   },
]
export default imageData;